import React, { createContext, useEffect, useCallback, useContext, useMemo, useState } from "react";
import { useAuth0 } from "@stadium/services/auth0";
import { useMutation } from "@stadium/services/apollo-client";
import { useRouter } from "next/router";

import { logoutCommonParams } from "@services/auth";
import { pubNubServiceInstance } from "@services/pubnub";
import { createSession } from "@graphql/mutations/session/create";

import { CurrentUserContext } from "@contexts/current-user-provider";

export const SloContext = createContext({});

const SloWrapper = ({ children }) => {
  const { isAuthenticated, logout } = useAuth0();
  const { asPath } = useRouter();
  const [createSessionRequest] = useMutation(createSession);
  const { currentUserData } = useContext(CurrentUserContext);
  const { spreeId: userId } = currentUserData;
  const [uid, setUid] = useState();
  const [sloChannel, setSloChannel] = useState();

  const createSessionHandler = useCallback(
    (userAgent) => {
      return createSessionRequest({ variables: { input: { userAgent } } });
    },
    [createSessionRequest]
  );

  const pbListener = useMemo(
    () => ({
      message: (messageEvent) => {
        if (messageEvent.message?.slo === true) {
          logout(logoutCommonParams(asPath));
        }
      },
    }),
    [logout, asPath]
  );

  useEffect(() => {
    let pubnub = null;

    if (isAuthenticated && userId) {
      createSessionHandler(window.navigator.userAgent)
        .then(({ data }) => {
          const { uid, channel } = data?.createSession || {};
          setUid(uid);
          setSloChannel(channel);

          pubnub = pubNubServiceInstance(uid);
          pubnub.addListener(pbListener);
          pubnub.subscribe({ channels: [channel] });
        })
        .catch((error) => {
          throw error;
        });
      return () => {
        if (pubnub) {
          pubnub.removeListener(pbListener);
          pubnub.unsubscribeAll();
        }
      };
    }
  }, [isAuthenticated, userId, pbListener, createSessionHandler]);

  const value = useMemo(() => {
    return { sloChannel, uid };
  }, [sloChannel, uid]);

  return <SloContext.Provider value={value}>{children}</SloContext.Provider>;
};

export default SloWrapper;
